<template>
  <div class="bg-blog max-w-main">
    <div class="p-1 relative" style="background: rgba(244, 244, 233, 0.60); height: 45px;" >
        <img class="ml-8 h-8 absolute z-50" @click="toHomePage" src="../../assets/logo_web.png" >
    </div>
    <div class="mt-4 p-3 color-main">
        <!-- <div class="title-mid">
            BLOG
        </div> -->
        <slide></slide>

        <select @change="fetchListBlog" v-model="category_id" class="w-full mt-4 shadow-input font-bold focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent rounded-sm p-1" name="cars" id="cars">
            <option v-for="item in category" :key="item.id" :value="item.id"> {{item.name}}</option>
            <!-- <option value="saab">Vay tín chấp bằng CMND/ CCCD</option>
            <option value="opel">Vay tín chấp bằng sổ hộ khẩu</option> -->
        </select>

        <div class="mt-4 mb-4">
            <div class="font-bold text-xl">
                BÀI VIẾT MỚI
            </div>
            <div class="mt-4" v-for="i in data_list" :key="i.id">
                <img class="max-h-40 w-full" @click="viewDetail(i.id,i.slug)" :src="i.image" />
                <div @click="viewDetail(i.id,i.slug)" class="font-bold mt-3">
                    {{ i.name }}
                </div>
                <div class=" grid grid-cols-2 mt-2">
                    <div class="color-main2 font-bold ">
                        <span class="text-border"> {{ i.category_name }} </span>
                    </div>
                    <div class="text-right font-bold text-sm">
                        {{ i.created_time | toHMDMY }}
                    </div>
                </div>

                <div class="mt-2 text-desc text-sm text-black">
                    {{i.description}}
                </div>
                <div>
                    <span @click="viewDetail(i.id,i.slug)" class="bg-main p-1 font-bold text-white rounded text-xs">Đọc tiếp <b-icon class="font-bold" style="color: white;" scale="1" icon="chevron-double-right" aria-hidden="true"></b-icon></span>
                </div>
            </div>
            
        </div>
        
        <div>
            <b-pagination align="center" @change="changePage" :per-page="page_size" v-model="page"  :total-rows="total"></b-pagination>
        </div>
        
        <!-- <div class="mgt-20">
            <div class="ft-16 fw-700">
                Mới nhất
            </div>
            <div class="mgt-10" style="overflow: auto;white-space: nowrap; height: 50px;padding-top: 10px;">
                <span style="margin-right: 10px; height: 30px;margin-top: 5px;" v-for="(i,index) in category"
                        :key="i.id">
                    <span v-if="c_active == index" class="active-btn category-btn main-center pd-5 mgt-10">
                        {{ i.name }}
                    </span>
                    <span @click="changeCategory(index,i.id)" v-else class="category-btn main-center content-box-app pd-5 mgt-10">
                        {{ i.name }}
                    </span>
                </span>
            </div>
            
            <div v-for="i in data_list" :key="i.id" class="mgt-10" style="margin-bottom: 20px;">
                <div @click="viewDetail(i.id,i.slug)">
                    <img  height="176" width="100%" style="border-radius: 10px;" :src="i.image" fluid alt="Responsive image">
                </div>
                <div @click="viewDetail(i.id,i.slug)" class="fw-700 mgt-10 ft-16">
                    {{ i.name }}
                </div>
                <div style="color: grey;" class="mgt-10">
                    <b-row>
                        <b-col>
                            {{ i.category_name }}
                        </b-col>
                        <b-col style="text-align: right;">
                            {{ i.updated_time | toDMY }}
                        </b-col>
                    </b-row>
                </div>
            </div>

            <div>
                 <b-pagination align="center" @change="changePage" :per-page="page_size" v-model="page"  :total-rows="total"></b-pagination>
            </div>

        </div> -->
    </div>
    
  </div>
</template>

<script>
import Slide from './components/slide.vue'
import { getHotBlog,getListBlog,getCategoryBlog, verifyOtp } from '@/api/otp'
import subRoute from '@/router/subRoute'

export default {
    components: { Slide, },
    data(){
        return{
            total: 100,
            currentPage: 1,
            category: [
                {
                    id: undefined,
                    name: 'Tất cả',
                },
                {
                    id: 1,
                    name: 'Danh mục 1',
                },{
                    id: 2,
                    name: 'Danh mục 2',
                },
                {
                    id: 3,
                    name: 'Danh mục 3',
                },
                {
                    id: 4,
                    name: 'Danh mục 4',
                },
                {
                    id: 5,
                    name: 'Danh mục 5',
                }
            ],
            news: [
                {
                    id: 1,
                    img: 'https://picsum.photos/1024/400/?image=41',
                    title: 'Vay tiền trung hạn và dài hạn là gì?',
                    category: 'Danh mục 1',
                    date: '11/12/2022'
                },
                {
                    id: 2,
                    img: 'https://picsum.photos/1024/400/?image=41',
                    title: 'Vay tiền trung hạn và dài hạn là gì?',
                    category: 'Danh mục 2',
                    date: '11/12/2022'
                },
            ],
            data_hot: [
                {
                    id: 2,
                    image: 'https://picsum.photos/1024/400/?image=41',
                    name: 'Vay tiền trung hạn và dài hạn là gì?',
                    category_name: 'Danh mục 2',
                    date: '11/12/2022'
                },
                {
                    id: 3,
                    image: 'https://picsum.photos/1024/400/?image=41',
                    name: 'Vay tiền trung hạn và dài hạn là gì?',
                    category_name: 'Danh mục 2',
                    date: '11/12/2022'
                },
                {
                    id: 4,
                    image: 'https://picsum.photos/1024/400/?image=41',
                    name: 'Vay tiền trung hạn và dài hạn là gì?',
                    category_name: 'Danh mục 2',
                    date: '11/12/2022'
                },
                {
                    id: 5,
                    image: 'https://picsum.photos/1024/400/?image=41',
                    name: 'Vay tiền trung hạn và dài hạn là gì?',
                    category_name: 'Danh mục 2',
                    date: '11/12/2022'
                },
            ],
            data_list: [],
            c_active: 0,
            page_size: 5,
            page: 1,
            category_id: undefined,
        }
    },
    methods: {
        toHomePage(){
            let r = subRoute
            this.$router.push(r)
        },
        viewDetail(id,slug){
            console.log('ok')
            let r = subRoute + 'blog/chi-tiet/' +id +'/'+slug
            console.log(r)
            this.$router.push(r)
        },
        fetchHotBlog(){
            getHotBlog({}).then(res => {
                this.data_hot = res.data
            })
        },
        changePage(page){
            console.log(page)
            this.page = page
            this.fetchListBlog()
        },
        changeCategory(index,id){
            this.c_active = index
            this.category_id = id
            this.fetchListBlog()
        },
        fetchListBlog(){
            getListBlog({
                page: parseInt(this.page),
                page_size: this.page_size,
                category_id: this.category_id
            }).then(res=> {
                this.data_list = res.data
                this.total = res.total_page
            })
        },
        fetchCategoryBlog(){
            getCategoryBlog({}).then(res => {
                let arr = [{
                    id: undefined,
                    name: 'Chọn chuyên mục',
                }];
                this.category = res.data
                this.category = arr.concat(this.category)
            })
        }
    },
    created(){
                    console.log('ok')

        this.fetchCategoryBlog()
        //this.fetchHotBlog()
        this.fetchListBlog()
    }
}
</script>

<style>
.text-desc {
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    -webkit-line-clamp: 2;
    height: 40px;
     display: -webkit-box;
    -webkit-box-orient: vertical;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    color: #862d99;
    
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px !important;
    min-width: 33.8px;
}

.page-item {
    margin-left: 5px;
}

.page-item.active .page-link {
    z-index: 3;
    color: #F1674A;
    background-color: #FEF0ED;
    border-color: #F1674A;
}
</style>